import { render } from "./PaypalButton.vue?vue&type=template&id=4cfc7bf4"
import script from "./PaypalButton.vue?vue&type=script&lang=js"
export * from "./PaypalButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__